import { LolloBernie as LolloBernie$2 } from './LolloBernie.style.js';
import { jsx } from 'react/jsx-runtime';

var LolloBernie = function LolloBernie(_ref) {
  var lazy = _ref.lazy;
  return /*#__PURE__*/jsx(LolloBernie$2, {
    src: "https://img.ving.se/image/upload/v1635498988/web/lollo_and_bernie.png",
    alt: "lollo&bernie",
    loading: lazy ? 'lazy' : 'eager'
  });
};
LolloBernie.defaultProps = {
  lazy: false
};
var LolloBernie$1 = LolloBernie;

export { LolloBernie$1 as default };
//# sourceMappingURL=LolloBernie.js.map
